<template>
  <div>
    <div v-if="is_disable_by_date">
      <v-icon icon="mdi-alert" color="red-darken-4"></v-icon>Le PPS est valable 3 mois. Vous pourrez réaliser votre PPS
      à partir du {{ date_validite_pps }} et revenir indiquer le numéro d'attestation PPS dans votre fiche
      d'inscription. Un mail
      automatique de relance vous sera envoyé.
    </div>
    <a v-if="!is_disable_by_date" href="https://pps.athle.fr/" target="_blank"><v-btn color="primary-dark"
        variant="elevated" elevation="0" size="small">Faire mon PPS</v-btn></a>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span>
      <v-btn class="ml-1" density="compact" color="primary-dark" variant="elevated" elevation="0"
        icon="mdi-information-variant" rounded @click="dialog_info_pps = true"></v-btn></label>
    <div class="text-subtitle-2" v-if="mainStore.module && mainStore.module.base == 'VVX26'">
      L'organisation rappelle que le trail constitue un effort important et conséquent. Il est donc vivement conseillé
      aux personnes présentant des pathologies cardiaques ou respiratoires de consulter un médecin avant de participer à
      l’événement.
    </div>
    <v-text-field v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable || is_disable_by_date" :hint="get_hint"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode, is_ffa)]"></v-text-field>

    <v-dialog v-model="dialog_response_webservice_success" max-width="400px">
      <v-card class="pa-2">
        <v-card-title>Pass Prévention Santé</v-card-title>
        <v-card-text><v-icon icon="mdi-check" color="green-darken-4"></v-icon> Votre numéro de PPS a été validé par la
          FFA</v-card-text>

        <v-card-actions>
          <v-btn color="primary-dark" text @click="dialog_response_webservice_success = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_response_webservice_error" max-width="400px">
      <v-card class="pa-2">
        <v-card-title>Pass Prévention Santé</v-card-title>
        <v-card-text>
          <div class="text-red-darken-4"><v-icon icon="mdi-alert"></v-icon> <b>{{ webservice_readable_error }}</b></div>
          <v-divider class="my-2"></v-divider>
          <div><b>Nom:</b> {{ inscription.coureur.champs.nom.value }}</div>
          <div><b>Prénom:</b> {{ inscription.coureur.champs.prenom.value }}</div>
          <div><b>Sexe:</b> {{ inscription.coureur.champs.sexe.value }}</div>
          <div><b>Date de naissance:</b> {{ get_french_date(inscription.coureur.champs.date_naissance.value) }}</div>
          <div><b>Numéro de PPS:</b> {{ last_pps_value }}</div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="darkblue" text @click="dialog_response_webservice_error = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--     <v-snackbar v-model="snackbar_success" timeout="3000">
      <div>Votre numéro de PPS est validé par la FFA</div>

      <template v-slot:actions>
        <v-btn color="green-darken-1" variant="elevated" @click="snackbar_success = false"> Fermer </v-btn>
      </template>
</v-snackbar>
<v-snackbar v-model="snackbar_error" timeout="3000">
  <div>Votre numéro de PPS n'est pas valide, ou ne correspond pas à l'identité du participant</div>

  <template v-slot:actions>
        <v-btn color="red-darken-1" variant="elevated" @click="snackbar_error = false"> Fermer </v-btn>
      </template>
</v-snackbar> -->
    <v-dialog v-model="dialog_info_pps" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <PPSMessage :with_image="true"></PPSMessage>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ms-auto" text="Fermer" @click="dialog_info_pps = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PPSMessage from "@/components/Home/PPS_Message.vue";
export default {
  components: { PPSMessage },
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      last_field_change: null,
      last_pps_value: null,
      webservice_readable_error: "",
      dialog_response_webservice_success: false,
      dialog_response_webservice_error: false,
      current_champ: {},
      snackbar_success: false,
      snackbar_error: false,
      dialog_info_pps: false,
      is_first_run: true,
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {

        this.current_champ = this.champ;

        this.$forceUpdate();
      },
    },

    'current_champ.value': {
      async handler() {
        if (this.is_first_run) {
          this.is_first_run = false;
          return;
        }

        this.verify_pps_on_webservice();

      },
    },
    "inscription.coureur.champs.nom": {
      deep: true,
      async handler() {

        this.verify_pps_on_webservice("nom");
      },
    },
    "inscription.coureur.champs.prenom": {
      deep: true,
      async handler() {

        this.verify_pps_on_webservice("prénom");
      },
    },
    "inscription.coureur.champs.sexe": {
      deep: true,
      async handler() {

        this.verify_pps_on_webservice("sexe");
      },
    },

    "inscription.coureur.champs.date_naissance": {
      deep: true,
      async handler() {

        this.verify_pps_on_webservice("date de naissance");
      },
    },
  },
  computed: {
    ...mapStores(useMainStore),
    is_ffa() {
      return this.mainStore.module.is_ffa_module;
    },

    date_validite_pps() {
      let date_fin = this.mainStore.module.evenement.date_fin;
      return this.$moment(date_fin).subtract(12, "months").format("DD/MM/YYYY");
    },
    is_disable_by_date() {
      let date_fin = this.mainStore.module.evenement.date_fin;
      return this.$moment(date_fin).diff(this.$moment(), "months") >= 12;
    },
    get_hint() {
      if (this.current_champ.nom == "numero_pps") {
        return "Accepté : Numéro de PPS (11 caractères)";
      }
      return "";
    },
  },
  methods: {
    get_french_date(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },

    async verify_pps_on_webservice(field_change = null) {
      this.last_field_change = field_change;
      this.inscription.coureur.unvalidate_document();
      let disable_webservice = this.mainStore.module.disable_webservice_ffa;
      let num_ffa = this.mainStore.module.ffa_num_competition;
      if (disable_webservice || !num_ffa || num_ffa == "" || !this.current_champ.is_valid_num_pps() || this.is_disable_by_date) {
        return;
      }

      let response = await this.inscription.coureur.try_fetch_pps_webservice(num_ffa);
      if (response) {
        if (response.valid_ffa) {
          this.dialog_response_webservice_success = true;
          this.$emit("pps_validated");
        } else {
          this.last_pps_value = this.current_champ.value;
          this.webservice_readable_error = this.get_readable_error(response.message);
          this.dialog_response_webservice_error = true;
          this.current_champ.value = "";
        }
      }

    },
    get_readable_error(error) {
      if (error == 'numero_pps manquant') return "Le numéro PPS est manquant ou incorrect";
      if (error == 'id_inscription manquant' || error == 'num_ffa manquant') return "Une erreur est survenue";
      if (error.includes("PLUS VALIDE AU MOMENT DE LA COMPETITION")) {
        return "Votre numéro de PPS est trop ancien pour cet évenement";
      }
      if (error.includes("IDENTITE DIFFERENTE")) {
        return "Les informations de votre PPS ne correspondent pas à vos informations d'inscription, veuillez vérifier que les informations renseignées soient STRICTEMENT identiques";
      }
      if (error.includes('INTROUVABLE')) {
        return "Le numéro de PPS renseigné n'existe pas, veuillez vérifier le numéro sur votre attestation.";
      }
      if (error.includes('LE NOM NE CORRESPOND PAS')) {
        return "Le nom de famille renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      if (error.includes('LE PRENOM NE CORRESPOND PAS')) {
        return "Le prénom renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      if (error.includes('LA DATE DE NAISSANCE NE CORRESPOND PAS')) {
        return "La date de naissance renseignée sur votre PPS ne correspond pas à celle renseigné pour votre inscription";
      }
      if (error.includes('LE SEXE NE CORRESPOND PAS')) {
        return "Le sexe renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      return "Une erreur est survenue";

    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped></style>